
import { defineComponent, nextTick, PropType } from 'vue';
import { findClassBgColor, findClassColor } from '@/scss/StyleClassManager';
import { CouponStruct } from '@//models/Blocks/Itens/block-promo';
export default defineComponent({
    props:{
        coupon:{
            type: Object as PropType<CouponStruct|string>,
            default: ''
        },
    },
    data(){
        return {
            copiedShow: false,
            copiedStyle: {},
            couponName: '',
            label: '',
            couponBoxClass: {},
            couponTextClass: {},
            copiedText: 'Copied'
        };
    },
    watch:{
        coupon(value){
            this.updateCoupon(value);    
        }
    },
    mounted(){
        this.updateCoupon(this.coupon);    
    },
    methods: {
        async copyClick(){
            if(this.copiedShow){
                return;
            }

            this.copiedShow = true;
            try{
                navigator.clipboard.writeText(this.couponName);
            }
            catch(err){
                // STORE-20349 Log error  
                if(window.mub && window.mub.websiteEvents){
                  window.mub.websiteEvents.add('copyToClipboard', 'error', this.couponName, {e: err.message});
                }
            }

            //waiting DOM updated 
            await nextTick();

            // DOM is now updated
            let copied   = this.$refs.copied ?? null;
            let przcopy  = this.$refs.przcopy ?? null;
            let rCopied  = copied ? (copied as HTMLInputElement)?.getBoundingClientRect() : null;
            let rPrzcopy = przcopy ? (przcopy as HTMLInputElement)?.getBoundingClientRect() : null;
            let margin  = 30;
            let width   = (rCopied?.width??0) + (rPrzcopy?.width??0) + margin;
            setTimeout(() => {this.copiedStyle = {width: `max(100%,${width}px)`}}, 10);
            setTimeout(() => {
                this.copiedStyle = {};
                setTimeout(() => { this.copiedShow = false; }, 500);
            }, 1000);
        },
        updateCoupon(value: string| CouponStruct){
            if(typeof value == 'string' || value instanceof String){
                this.couponName = value.toString();
                this.couponBoxClass = {['prz-blk-promo-coupon-box-bg']: true};
                this.couponTextClass = {['prz-blk-promo-coupon-text-color']: true};
            }else{
                this.couponName = value?.text??'';
                this.label = value?.label??'';
                if(value.color ?? null){
                    let classText = findClassColor(value?.color??'');
                    this.couponTextClass = {[classText??'prz-blk-promo-coupon-text-color']: true};
                }
                if(value.background ?? null){
                    let classBox = findClassBgColor(value?.background??'');
                    this.couponBoxClass = {[classBox??'prz-blk-promo-coupon-box-bg']: true};
                }
                this.copiedText = value.copied ?? 'Copied';
            }
        },
    }
});
